import {ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {finalize} from 'rxjs/operators';

import {TaskService} from './services/task.service';
import {TaskConverterService} from './services/task-converter.service';
import {TaskListViewModel} from './view-models/task-list.view-model';
import {LoadingAnimationComponent} from '@shared/components/loading-animation/loading-animation.component';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, LoadingAnimationComponent]
})
export class TasksComponent implements OnInit {

  private readonly taskService = inject(TaskService);
  private readonly taskConverterService = inject(TaskConverterService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly titleService = inject(Title);
  private readonly destroyRef = inject(DestroyRef);

  readonly dataLoading = signal(true);
  readonly dataAvailable = signal(false);
  readonly dataEmpty = signal(false);
  readonly tasks = signal<TaskListViewModel[]>([]);

  ngOnInit(): void {
    this.dataLoading.set(true);
    this.dataAvailable.set(false);
    this.titleService.setTitle('Portal - Tasks');
    this.taskService.getTasks()
      .pipe(
        finalize(() => {
          this.dataLoading.set(false);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: taskListDto => {
          this.tasks.set(this.taskConverterService.convertTaskListDtoToTaskListViewModels(taskListDto));
          this.dataEmpty.set(this.tasks().length === 0);
          this.dataAvailable.set(!this.dataEmpty());
        },
        error: error => {
          console.error('Error loading tasks', error);
          this.tasks.set([]);
          this.dataEmpty.set(true);
          this.dataAvailable.set(false);
        }
      });
  }
}
